@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.categories.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.categories.resources/"

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.categories_back_a11y: StringResource by lazy {
      StringResource("string:categories_back_a11y", "categories_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 36),
      ))
    }

@delegate:ResourceContentHash(1_029_465_286)
internal val Res.string.categories_business_count: StringResource by lazy {
      StringResource("string:categories_business_count", "categories_business_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 55, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47, 53),
      ))
    }

@delegate:ResourceContentHash(1_368_805_043)
internal val Res.string.categories_cta_action: StringResource by lazy {
      StringResource("string:categories_cta_action", "categories_cta_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 121, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 105, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101, 45),
      ))
    }

@delegate:ResourceContentHash(1_986_324_672)
internal val Res.string.categories_cta_subtitle: StringResource by lazy {
      StringResource("string:categories_cta_subtitle", "categories_cta_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 163, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 147, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147, 91),
      ))
    }

@delegate:ResourceContentHash(-2_035_614_537)
internal val Res.string.categories_cta_title: StringResource by lazy {
      StringResource("string:categories_cta_title", "categories_cta_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 307, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239, 52),
      ))
    }

@delegate:ResourceContentHash(18_635_520)
internal val Res.string.categories_error: StringResource by lazy {
      StringResource("string:categories_error", "categories_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 404, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 308, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292, 60),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.categories_retry: StringResource by lazy {
      StringResource("string:categories_retry", "categories_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 497, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 385, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353, 36),
      ))
    }

@delegate:ResourceContentHash(-1_657_740_305)
internal val Res.string.categories_search_empty: StringResource by lazy {
      StringResource("string:categories_search_empty", "categories_search_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 550, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 426, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 390, 75),
      ))
    }

@delegate:ResourceContentHash(706_740_390)
internal val Res.string.categories_search_placeholder: StringResource by lazy {
      StringResource("string:categories_search_placeholder", "categories_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 666, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 522, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 466, 65),
      ))
    }

@delegate:ResourceContentHash(-894_852_049)
internal val Res.string.categories_subtitle: StringResource by lazy {
      StringResource("string:categories_subtitle", "categories_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 748, 191),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 600, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 532, 107),
      ))
    }

@delegate:ResourceContentHash(-650_874_864)
internal val Res.string.categories_title: StringResource by lazy {
      StringResource("string:categories_title", "categories_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 940, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 736, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 640, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("categories_back_a11y", Res.string.categories_back_a11y)
  map.put("categories_business_count", Res.string.categories_business_count)
  map.put("categories_cta_action", Res.string.categories_cta_action)
  map.put("categories_cta_subtitle", Res.string.categories_cta_subtitle)
  map.put("categories_cta_title", Res.string.categories_cta_title)
  map.put("categories_error", Res.string.categories_error)
  map.put("categories_retry", Res.string.categories_retry)
  map.put("categories_search_empty", Res.string.categories_search_empty)
  map.put("categories_search_placeholder", Res.string.categories_search_placeholder)
  map.put("categories_subtitle", Res.string.categories_subtitle)
  map.put("categories_title", Res.string.categories_title)
}
